import { useGetEntity } from '@abaninja/util-store';

import { getSenderDetails } from '../sender-details';

export const useSenderStore = () => useGetEntity(getSenderDetails);
